import Axios from "../util/axiosInstance";

export const loginApi = (payload) => {
  return Axios.post("/api/user/login", payload)
};